<template>
  <div>
    <md-content>
      <viewer
        :content="true"
        :embed="true"
        :mode="mode"
        :nid="nid"
        :sid="sid"
        field="field_ready_form"
      />
    </md-content>
  </div>
</template>

<script>
import Viewer from "./Viewer.vue";
export default {
  name: "Ready",
  props: ["mode", "nid", "sid"],
  activated() {
    if (this.$route.params.component && this.$route.params.component != "") {
      this.subroute = true;
    }
    setTimeout(() => {
      window.H5P.init();
    }, 0);
    this.$emit('ready-active');
  },
  data() {
    return {
      subroute: false,
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || ""
    };
  },
  components: {
    Viewer
  }
};
</script>
